import type { CSSProperties } from "react";

export function CustomAlert({ heading, message, onClose }: { heading: string; message: string; onClose: () => void }) {
  return (
    <>
      <div className="custom-alert-overlay"></div>
      <div className="custom-alert">
        <div className="custom-alert-content">
          <span className="heading">{heading}</span>
          <span className="message">{message}</span>
          <button onClick={onClose} className="custom-alert-close">
            Close
          </button>
        </div>
      </div>
    </>
  );
}

export function CustomDialog({ heading, content, onClose }: { heading: string; content: string; onClose: () => void }) {
  return (
    <>
      <div className="custom-alert-overlay"></div>
      <div className="custom-alert">
        <div className="custom-alert-content">
          <span className="heading">{heading}</span>
          <span className="content">{content}</span>
          <button onClick={onClose} className="custom-alert-close">
            Close
          </button>
        </div>
      </div>
    </>
  );
}

export function LoadingOverlay() {
  const overlayStyle: CSSProperties = {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent overlay
      zIndex: 1000, // Ensure it is above other content
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    };
  
    const spinnerStyle: CSSProperties = {
      border: '8px solid #f3f3f3', // Light grey
      borderTop: '8px solid #3498db', // Blue
      borderRadius: '50%',
      width: '60px',
      height: '60px',
      animation: 'spin 2s linear infinite',
    };
  
    return (
      <div style={overlayStyle}>
        <div style={spinnerStyle}></div>
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
      </div>
    );
  }
  


